import {
  ChemDrawStoichiometryData,
  ParseReactionComponentsResponse,
  ReactionFormat,
} from 'chemistry/ChemistryConstants';
import * as net from 'util/Net';

export function bulkFetchChemDrawStoichiometryData(
  noteLinkedObjectIds: Array<string>
): Promise<{[noteLinkedObjectId: string]: ChemDrawStoichiometryData}> {
  return net.postJSONPromise({
    url: '/1/api/chemistry:bulk-fetch-chemdraw-stoichiometry-data',
    data: {noteLinkedObjectIds},
  });
}

export function parseReactionComponents(
  reactionFile: string,
  reactionFormat: ReactionFormat
): Promise<ParseReactionComponentsResponse> {
  return net.postJSONPromise({
    url: '/1/api/reactions:parse-components',
    data: {reactionFile, reactionFormat},
  });
}
